<app-expandable-panel [cardType]="true">
  <div class="thropy-header">
    <div class="thropy-title">
      <label>
        Current Status:
        <span class="status" [ngClass]="awardsSummary?.lastYearAward">{{
          awardsSummary?.lastYearAward
        }}</span>
        <span
          class="accumulated-score"
          *ngIf="awardsSummary?.accumulatedScore && awardsSummary?.accumulatedScore > 0"
          >{{ 'Career: ' + awardsSummary?.accumulatedScore }}</span
        >
      </label>
      <app-tooltip (click)="showToolTipSidebar()"></app-tooltip>
    </div>
    <div class="progress-dial">
      <img
        [src]="'assets/progress-dial/sota-dial-' + (awardsSummary?.currentPoints || 0) + '.svg'"
      />
      <span>{{ nextYear }}</span>
      <span>Progress</span>
    </div>
    <hr class="divider" />
    <p class="comparison-text">{{ awardsSummary?.percentileMessage }}</p>
    <button class="btn-enroll" label="CLAIM AWARDS" (click)="enroll()" *ngIf="claimURL" pButton>
    </button>
  </div>
</app-expandable-panel>

<p-sidebar
  [blockScroll]="true"
  (onHide)="hideToolTipSidebar()"
  position="bottom"
  [showCloseIcon]="false"
  styleClass="cre-wig-awards-tooltip-sidebar"
  [(visible)]="isTooltipSidebarVisible"
>
  <div class="sidebar-topbar">
    <h2>Program information</h2>
    <div class="cre-wig-awards-tooltip-sidebar-icon" *ngIf="isTooltipSidebarVisible">
      <fa-icon (click)="hideToolTipSidebar()" [icon]="['fal', 'times']" [size]="'3x'"> </fa-icon>
    </div>
  </div>
  <div class="tooltip-content">
    <img class="img-title" src="assets/awards/title.png" />
    <p>
      Safe & On-Time Awards is a program designed to be a fun way to track your performance in C.R.
      England’s core values of Safety and Service. We want to recognize all of you for your hard
      work and diligence. This program is a positive reflection of your performance and we think it
      will assist you in improving and growing as a driver. Thank you for all you do!
    </p>
    <p class="content-subtitle">How it works</p>
    <p>
      Eligible drivers can earn up to 3 points each month in the following categories, which are
      identical to the Safe & On-Time Bonus categories.
    </p>
    <img src="assets/awards/personal-stats.png" />
    <ul>
      <li>
        <img class="n-one" src="assets/awards/n-one.png" />
        <span>No chargeable accidents or critical events</span>
      </li>
      <li>
        <img class="n-one" src="assets/awards/n-one.png" />
        <span>No driver service failures</span>
      </li>
      <li>
        <img class="n-one" src="assets/awards/n-one.png" />
        <span
          >Keep all daily 4DX commitments, attend all huddles, and watch the monthly safety
          video.</span
        >
      </li>
    </ul>
    <p class="content-subtitle">Status points</p>
    <p>
      Status points accumulate each month and count towards your career points. In January of each
      calendar year, the status points reset to zero and you start accumulating points again.
    </p>
    <img src="assets/awards/status-points.png" />
    <p class="content-subtitle">Status level</p>
    <p>You retain the status level that you earned from the prior year for the following year.</p>
    <img src="assets/awards/status-level.png" />
    <p>
      If you reach a higher status during the current year, then you will be recognized at the
      higher status level. As you reach a status level, you will be eligible to redeem an award of
      your choosing.
    </p>
    <p>The following chart describes the status points associated with each level.</p>
    <img class="content-status" src="assets/awards/status.png" />
    <p class="content-subtitle">Career points</p>
    <p>
      Career points earned will last throughout your driving career at C.R. England. Career points
      do not expire. They continue to build each year.
    </p>
    <img src="assets/awards/career-points.png" />
    <p class="content-subtitle">Your standing</p>
    <p>
      Your performance standing will display below your current progress, and will show how you’re
      doing compared to other drivers throughout the company.
    </p>
    <img src="assets/awards/your-standing.png" />
    <p class="content-subtitle">Claim awards</p>
    <p>
      If you’re eligible to claim an award, a button will display at the bottom of your progress
      card. Tap on this button to be taken to our awards shop where you may choose which award you
      would like to claim and have it shipped directly to you.
    </p>
    <img src="assets/awards/claim-award.png" />
    <p class="content-subtitle">Support</p>
    <p>If you find you need additional assistance, contact your fleet manager.</p>
  </div>
</p-sidebar>
